










import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class WhyFlexboxBox extends Vue {
  @Prop({ type: String })
  public title!: string;

  @Prop({ type: String })
  public icon!: string;

  private get darkMode(): boolean {
    return this.$store.state.darkMode;
  }
}
